function initCookieBar($t){
    $.cookieBar({
        element: 'body',
        zindex: '999999',
        message: $t,
        acceptText: '',
        domain: 'https://www.tzeranis.com/',
        referrer: 'https://www.tzeranis.com/'
    });
} 